export default {
  "apiKey": "a2c8e7d1-6f4b-9e2d-4a8c-5b6f8d9e1a3c",
  "apiUrl": "https://api-ruby-staging.roexaudio.com",
  "bucketName": "spatial-checker-staging-417314.appspot.com",
  "env": "staging",
  "debugMode": false
}